(function () {
  var button = document.getElementById('start_demo');
  var statusNode = document.getElementById('sensor-status');
  var warningNode = document.getElementById('sensor-warning');
  var warningTextNode = document.getElementById('sensor-warning-text');
  var counterNode = document.getElementById('num-observed-events');
  var parallaxBackNode = document.getElementById('sensor-parallax-back');
  var parallaxFrontNode = document.getElementById('sensor-parallax-front');

  if (!button || !statusNode || !counterNode) {
    return;
  }

  var isRunning = false;
  var observedCount = 0;
  var hasMotionEvent = 'DeviceMotionEvent' in window;
  var hasOrientationEvent = 'DeviceOrientationEvent' in window;
  var parallaxAnimationFrame = 0;
  var parallaxTargetX = 0;
  var parallaxTargetY = 0;
  var parallaxCurrentX = 0;
  var parallaxCurrentY = 0;
  var supportCheckTimeout = 0;
  var eventsSinceStart = 0;

  function setStatus(message) {
    statusNode.textContent = message;
  }

  function setWarning(message) {
    if (!warningNode) {
      return;
    }

    warningNode.hidden = !message;
    if (warningTextNode) {
      warningTextNode.textContent = message || '';
      return;
    }

    warningNode.textContent = message || '';
  }

  function clearWarning() {
    setWarning('');
  }

  function setButtonState(running) {
    isRunning = running;
    button.textContent = running ? 'Stop demo' : 'Start demo';
    button.setAttribute('aria-pressed', running ? 'true' : 'false');
  }

  function incrementEventCount() {
    observedCount += 1;
    if (isRunning) {
      eventsSinceStart += 1;
      if (supportCheckTimeout && eventsSinceStart > 0) {
        window.clearTimeout(supportCheckTimeout);
        supportCheckTimeout = 0;
      }
    }
    counterNode.textContent = String(observedCount);
  }

  function scheduleNoEventWarning() {
    if (supportCheckTimeout) {
      window.clearTimeout(supportCheckTimeout);
    }

    supportCheckTimeout = window.setTimeout(function () {
      if (!isRunning || eventsSinceStart > 0) {
        return;
      }

      setWarning('No sensor events were received after starting. Try a real mobile device, HTTPS, and allow Motion/Orientation access in the browser/site settings.');
    }, 2500);
  }

  function clearNoEventWarningTimer() {
    if (!supportCheckTimeout) {
      return;
    }

    window.clearTimeout(supportCheckTimeout);
    supportCheckTimeout = 0;
  }

  function updatePreflightWarning() {
    var warnings = [];
    var reducedMotionQuery;

    if (!hasMotionEvent && !hasOrientationEvent) {
      warnings.push('This browser does not expose motion/orientation sensor APIs.');
    }

    if (!window.isSecureContext) {
      warnings.push('Sensor access may require HTTPS (secure context).');
    }

    if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches === false) {
      warnings.push('This appears to be a non-touch/pointer-fine device (desktop/laptop), so live sensor values may be unavailable.');
    }

    if (supportsPermissionRequest()) {
      warnings.push('This browser uses a permission-gated sensor API. Press Start to request access if needed; a permission prompt may appear depending on browser/device settings and prior grants.');
    }

    if (window.matchMedia) {
      reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (reducedMotionQuery.matches) {
        warnings.push('Reduced motion is enabled on this device; motion-reactive demos may be uncomfortable.');
      }
    }

    setWarning(warnings.join(' '));
  }

  function updateFieldIfNotNull(fieldName, value, precision) {
    var node;
    if (value == null) {
      return;
    }
    node = document.getElementById(fieldName);
    if (!node) {
      return;
    }
    node.textContent = Number(value).toFixed(precision == null ? 10 : precision);
  }

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function renderParallax() {
    var nextX;
    var nextY;

    if (!parallaxBackNode && !parallaxFrontNode) {
      parallaxAnimationFrame = 0;
      return;
    }

    nextX = parallaxCurrentX + ((parallaxTargetX - parallaxCurrentX) * 0.16);
    nextY = parallaxCurrentY + ((parallaxTargetY - parallaxCurrentY) * 0.16);

    if (Math.abs(parallaxTargetX - nextX) < 0.002) {
      nextX = parallaxTargetX;
    }

    if (Math.abs(parallaxTargetY - nextY) < 0.002) {
      nextY = parallaxTargetY;
    }

    parallaxCurrentX = nextX;
    parallaxCurrentY = nextY;

    if (parallaxBackNode) {
      parallaxBackNode.style.transform =
        'translate3d(' + (parallaxCurrentX * -4).toFixed(2) + 'px, ' + (parallaxCurrentY * -3).toFixed(2) + 'px, 0) scale(1)';
    }

    if (parallaxFrontNode) {
      parallaxFrontNode.style.transform =
        'translate3d(' + (parallaxCurrentX * 6).toFixed(2) + 'px, ' + (parallaxCurrentY * 4).toFixed(2) + 'px, 0) scale(1)';
    }

    if (
      parallaxCurrentX !== parallaxTargetX ||
      parallaxCurrentY !== parallaxTargetY ||
      isRunning
    ) {
      parallaxAnimationFrame = window.requestAnimationFrame(renderParallax);
      return;
    }

    parallaxAnimationFrame = 0;
  }

  function ensureParallaxAnimation() {
    if (parallaxAnimationFrame) {
      return;
    }

    parallaxAnimationFrame = window.requestAnimationFrame(renderParallax);
  }

  function updateParallaxFromOrientation(beta, gamma) {
    var x;
    var y;

    if (!parallaxBackNode && !parallaxFrontNode) {
      return;
    }

    if (beta == null && gamma == null) {
      return;
    }

    x = clamp(Number(gamma || 0), -45, 45) / 45;
    y = clamp(Number(beta || 0), -45, 45) / 45;

    if (Math.abs(x - parallaxTargetX) < 0.01 && Math.abs(y - parallaxTargetY) < 0.01) {
      return;
    }

    parallaxTargetX = x;
    parallaxTargetY = y;
    ensureParallaxAnimation();
  }

  function handleOrientation(event) {
    updateFieldIfNotNull('Orientation_a', event.alpha, 10);
    updateFieldIfNotNull('Orientation_b', event.beta, 10);
    updateFieldIfNotNull('Orientation_g', event.gamma, 10);
    updateParallaxFromOrientation(event.beta, event.gamma);
    incrementEventCount();
  }

  function handleMotion(event) {
    var accelWithGravity = event.accelerationIncludingGravity || {};
    var accel = event.acceleration || {};
    var rotation = event.rotationRate || {};

    updateFieldIfNotNull('Accelerometer_gx', accelWithGravity.x, 10);
    updateFieldIfNotNull('Accelerometer_gy', accelWithGravity.y, 10);
    updateFieldIfNotNull('Accelerometer_gz', accelWithGravity.z, 10);

    updateFieldIfNotNull('Accelerometer_x', accel.x, 10);
    updateFieldIfNotNull('Accelerometer_y', accel.y, 10);
    updateFieldIfNotNull('Accelerometer_z', accel.z, 10);
    updateFieldIfNotNull('Accelerometer_i', event.interval, 2);

    updateFieldIfNotNull('Gyroscope_z', rotation.alpha, 10);
    updateFieldIfNotNull('Gyroscope_x', rotation.beta, 10);
    updateFieldIfNotNull('Gyroscope_y', rotation.gamma, 10);
    incrementEventCount();
  }

  function stopListeners() {
    window.removeEventListener('devicemotion', handleMotion);
    window.removeEventListener('deviceorientation', handleOrientation);
    clearNoEventWarningTimer();
    setButtonState(false);
    setStatus('Stopped. Press Start demo to listen again.');
    parallaxTargetX = 0;
    parallaxTargetY = 0;
    ensureParallaxAnimation();
    updatePreflightWarning();
  }

  function startListeners() {
    window.addEventListener('devicemotion', handleMotion);
    window.addEventListener('deviceorientation', handleOrientation);
    eventsSinceStart = 0;
    scheduleNoEventWarning();
    setButtonState(true);
    setStatus('Listening for motion/orientation events... move or rotate your device.');
    ensureParallaxAnimation();
  }

  function supportsPermissionRequest() {
    return hasMotionEvent && typeof window.DeviceMotionEvent.requestPermission === 'function';
  }

  async function requestSensorPermissionIfNeeded() {
    var motionResult;
    var orientationResult;

    if (!supportsPermissionRequest()) {
      return true;
    }

    try {
      motionResult = await window.DeviceMotionEvent.requestPermission();
      if (hasOrientationEvent && typeof window.DeviceOrientationEvent.requestPermission === 'function') {
        orientationResult = await window.DeviceOrientationEvent.requestPermission();
      }

      if (motionResult !== 'granted') {
        setStatus('Permission denied for motion sensors.');
        return false;
      }

      if (orientationResult && orientationResult !== 'granted') {
        setStatus('Motion allowed, but orientation permission was denied.');
        return true;
      }

      return true;
    } catch (error) {
      setStatus('Sensor permission request failed. ' + (error && error.message ? error.message : ''));
      return false;
    }
  }

  async function onToggle() {
    if (isRunning) {
      stopListeners();
      return;
    }

    if (!hasMotionEvent && !hasOrientationEvent) {
      setStatus('This browser does not expose DeviceMotionEvent or DeviceOrientationEvent.');
      return;
    }

    if (!window.isSecureContext && supportsPermissionRequest()) {
      setStatus('This browser likely requires HTTPS before motion/orientation access can be granted.');
      return;
    }

    setStatus('Requesting sensor access...');

    if (!(await requestSensorPermissionIfNeeded())) {
      setButtonState(false);
      return;
    }

    startListeners();
  }

  button.addEventListener('click', function (event) {
    event.preventDefault();
    onToggle();
  });

  if (!hasMotionEvent && !hasOrientationEvent) {
    setStatus('Unsupported in this browser. Try a modern mobile browser on a phone or tablet.');
  }

  updatePreflightWarning();
}());
